/**
 * Use it to create simple modal controllers
 */

import { ref } from 'vue';

export function useModal() {
    const isOpen = ref(false);
    const isOpenWithFocus = ref(false);

    const open = () => {
        isOpen.value = true;
    };

    const close = () => {
        isOpen.value = false;
    };

    const openWithFocus = () => {
        isOpenWithFocus.value = true;
    };

    const closeWithFocus = () => {
        isOpenWithFocus.value = false;
    };

    return {
        isOpen: computed(() => isOpen.value),
        isOpenWithFocus: computed(() => isOpenWithFocus.value),
        open,
        openWithFocus,
        close,
        closeWithFocus
    };
}
